import mock from "../mock";
import { paginateArray } from "../utils";

const data = {
  users: [
    {
      id: 1,
      fullName: "Mohamed Gamal",
      company: "Yotz PVT LTD",
      role: "editor",
      username: "mohmedgamal",
      country: "El Salvador",
      contact: "(479) 232-9151",
      email: "mohamed@gmail.com",
      phone: "+20 1091996900",
      studyPhase: "secondary",
      gender: "male",
      paid: "paid",
      blocked: "blocked",
      login: "pc",
      classNumber: "3rd",
      loginMethod: "facebook",
      currentPlan: "enterprise",
      status: "inactive",
      avatar: "",
    },
    {
      id: 2,
      fullName: "Sami Ahmed",
      company: "Skinder PVT LTD",
      role: "author",
      username: "samiahmed",
      country: "Albania",
      contact: "(472) 607-9137",
      email: "sami@gmail.com",
      phone: "+20 1000996900",
      studyPhase: "primary",
      gender: "male",
      paid: "unpaid",
      blocked: "blocked",
      login: "ios",
      classNumber: "2nd",
      loginMethod: "facebook",
      currentPlan: "team",
      status: "pending",
      avatar: require("@src/assets/images/avatars/10.png").default,
    },
    {
      id: 3,
      fullName: "Sara Adel",
      company: "Oozz PVT LTD",
      role: "maintainer",
      username: "saraadel",
      country: "Russia",
      contact: "(321) 264-4599",
      email: "sara@gmail.com",
      phone: "+20 1111086800",
      studyPhase: "secondary",
      gender: "female",
      paid: "paid",
      blocked: "unblocked",
      login: "android",
      classNumber: "1st",
      loginMethod: "google",
      currentPlan: "enterprise",
      status: "active",
      avatar: require("@src/assets/images/avatars/1.png").default,
    },
    // {
    //   id: 4,
    //   fullName: "Cyrill Risby",
    //   company: "Oozz PVT LTD",
    //   role: "maintainer",
    //   username: "crisby3",
    //   country: "China",
    //   contact: "(923) 690-6806",
    //   email: "crisby3@wordpress.com",
    //   currentPlan: "team",
    //   status: "inactive",
    //   avatar: require("@src/assets/images/avatars/9.png").default,
    // },
    // {
    //   id: 5,
    //   fullName: "Maggy Hurran",
    //   company: "Aimbo PVT LTD",
    //   role: "subscriber",
    //   username: "mhurran4",
    //   country: "Pakistan",
    //   contact: "(669) 914-1078",
    //   email: "mhurran4@yahoo.co.jp",
    //   currentPlan: "enterprise",
    //   status: "pending",
    //   avatar: require("@src/assets/images/avatars/10.png").default,
    // },
    // {
    //   id: 6,
    //   fullName: "Silvain Halstead",
    //   company: "Jaxbean PVT LTD",
    //   role: "author",
    //   username: "shalstead5",
    //   country: "China",
    //   contact: "(958) 973-3093",
    //   email: "shalstead5@shinystat.com",
    //   currentPlan: "company",
    //   status: "active",
    //   avatar: "",
    // },
    // {
    //   id: 7,
    //   fullName: "Breena Gallemore",
    //   company: "Jazzy PVT LTD",
    //   role: "subscriber",
    //   username: "bgallemore6",
    //   country: "Canada",
    //   contact: "(825) 977-8152",
    //   email: "bgallemore6@boston.com",
    //   currentPlan: "company",
    //   status: "pending",
    //   avatar: "",
    // },
    // {
    //   id: 8,
    //   fullName: "Kathryne Liger",
    //   company: "Pixoboo PVT LTD",
    //   role: "author",
    //   username: "kliger7",
    //   country: "France",
    //   contact: "(187) 440-0934",
    //   email: "kliger7@vinaora.com",
    //   currentPlan: "enterprise",
    //   status: "pending",
    //   avatar: require("@src/assets/images/avatars/9.png").default,
    // },
    // {
    //   id: 9,
    //   fullName: "Franz Scotfurth",
    //   company: "Tekfly PVT LTD",
    //   role: "subscriber",
    //   username: "fscotfurth8",
    //   country: "China",
    //   contact: "(978) 146-5443",
    //   email: "fscotfurth8@dailymotion.com",
    //   currentPlan: "team",
    //   status: "pending",
    //   avatar: require("@src/assets/images/avatars/2.png").default,
    // },
    // {
    //   id: 10,
    //   fullName: "Jillene Bellany",
    //   company: "Gigashots PVT LTD",
    //   role: "maintainer",
    //   username: "jbellany9",
    //   country: "Jamaica",
    //   contact: "(589) 284-6732",
    //   email: "jbellany9@kickstarter.com",
    //   currentPlan: "company",
    //   status: "inactive",
    //   avatar: require("@src/assets/images/avatars/9.png").default,
    // },
    // {
    //   id: 11,
    //   fullName: "Jonah Wharlton",
    //   company: "Eare PVT LTD",
    //   role: "subscriber",
    //   username: "jwharltona",
    //   country: "United States",
    //   contact: "(176) 532-6824",
    //   email: "jwharltona@oakley.com",
    //   currentPlan: "team",
    //   status: "inactive",
    //   avatar: require("@src/assets/images/avatars/4.png").default,
    // },
    // {
    //   id: 12,
    //   fullName: "Seth Hallam",
    //   company: "Yakitri PVT LTD",
    //   role: "subscriber",
    //   username: "shallamb",
    //   country: "Peru",
    //   contact: "(234) 464-0600",
    //   email: "shallamb@hugedomains.com",
    //   currentPlan: "team",
    //   status: "pending",
    //   avatar: require("@src/assets/images/avatars/5.png").default,
    // },
    // {
    //   id: 13,
    //   fullName: "Yoko Pottie",
    //   company: "Leenti PVT LTD",
    //   role: "subscriber",
    //   username: "ypottiec",
    //   country: "Philippines",
    //   contact: "(907) 284-5083",
    //   email: "ypottiec@privacy.gov.au",
    //   currentPlan: "basic",
    //   status: "inactive",
    //   avatar: require("@src/assets/images/avatars/7.png").default,
    // },
    // {
    //   id: 14,
    //   fullName: "Maximilianus Krause",
    //   company: "Digitube PVT LTD",
    //   role: "author",
    //   username: "mkraused",
    //   country: "Democratic Republic of the Congo",
    //   contact: "(167) 135-7392",
    //   email: "mkraused@stanford.edu",
    //   currentPlan: "team",
    //   status: "active",
    //   avatar: require("@src/assets/images/avatars/9.png").default,
    // },
    // {
    //   id: 15,
    //   fullName: "Zsazsa McCleverty",
    //   company: "Kaymbo PVT LTD",
    //   role: "maintainer",
    //   username: "zmcclevertye",
    //   country: "France",
    //   contact: "(317) 409-6565",
    //   email: "zmcclevertye@soundcloud.com",
    //   currentPlan: "enterprise",
    //   status: "active",
    //   avatar: require("@src/assets/images/avatars/2.png").default,
    // },
  ],
};

// GET ALL DATA
mock.onGet("/api/users/list/all-data").reply(200, data.users);

// POST: Add new user
mock.onPost("/apps/users/add-user").reply((config) => {
  // Get event from post data
  const user = JSON.parse(config.data);

  const { length } = data.users;
  let lastIndex = 0;
  if (length) {
    lastIndex = data.users[length - 1].id;
  }
  user.id = lastIndex + 1;

  data.users.unshift(user);

  return [201, { user }];
});

// GET Updated DATA
mock.onGet("/api/users/list/data").reply((config) => {
  const {
    q = "",
    perPage = 10,
    page = 1,
    role = null,
    currentPlan = null,
    status = null,
    classNumber = null,
    email = null,
    phone = null,
    login = null,
    loginMethod = null,
  } = config;

  /* eslint-disable  */
  const queryLowered = q.toLowerCase();
  const filteredData = data.users.filter(
    (user) =>
      (user.username.toLowerCase().includes(queryLowered) ||
        user.fullName.toLowerCase().includes(queryLowered)) &&
      user.phone.includes(phone) &&
      user.email.includes(email) &&
      user.studyPhase === (role || user.studyPhase) &&
      user.paid === (currentPlan || user.paid) &&
      user.blocked === (status || user.blocked) &&
      user.login === (login || user.login) &&
      user.loginMethod === (loginMethod || user.loginMethod) &&
      user.classNumber === (classNumber || user.classNumber)
  );
  /* eslint-enable  */

  return [
    200,
    {
      users: paginateArray(filteredData, perPage, page),
      total: filteredData.length,
    },
  ];
});

// GET USER
mock.onGet("/api/users/user").reply((config) => {
  const { id } = config;
  const user = data.users.find((i) => i.id === id);
  return [200, { user }];
});

// DELETE: Deletes User
mock.onDelete("/apps/users/delete").reply((config) => {
  // Get user id from URL
  let userId = config.id;

  // Convert Id to number
  userId = Number(userId);

  const userIndex = data.users.findIndex((t) => t.id === userId);
  data.users.splice(userIndex, 1);

  return [200];
});
